module.exports = __webpack_public_path__ + "static/media/zoom_copy.588c60ba.svg";